import React from 'react';
import styles from './SaveAndCancel.module.css';

export const SaveAndCancel = ({
  onSave,
  onCancel,
  saveLabel = 'Save',
  cancelLabel = 'Cancel',
}) => {
  return (
    <div className={styles.buttonContainer}>
      <button className={styles.cancelButton} onClick={onCancel}>
        {cancelLabel}
      </button>
      <button className={styles.saveButton} onClick={onSave}>
        {saveLabel}
      </button>
    </div>
  );
};

export default SaveAndCancel;
